import React from "react";
import { useLocation, Link } from "react-router-dom";
import "./BreadCrumbs.css";

const capitalize = (text: string) =>
  text.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

const BreadCrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter(Boolean);

  return (
    <div className="breadcrumbs-wrapper">
      <Link to="/">Home</Link>

      {pathnames.map((name, index) => {
        const routeTo = "/" + pathnames.slice(0, index + 1).join("/");
        const isLast = index === pathnames.length - 1;

        return (
          <React.Fragment key={routeTo}>
            <span className="separator">›</span>

            {isLast ? (
              <span className="current">{capitalize(name)}</span>
            ) : (
              <Link to={routeTo}>{capitalize(name)}</Link>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default BreadCrumbs;
